import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'partDataLoading': false,
  'loading': false,
  'downloading': false,
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
  'itemsCount': 0,
  'partData': {},
  'balanceInfo': {},
  'list': [],
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > pageSize * (pageNumber + 1)) {
    return [...list].slice(pageSize * pageNumber, pageSize * (pageNumber + 1));
  }
  return [...list].slice(pageNumber * pageSize);
};

export const kardex = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_FILTERS]: (state, action) => ({
      ...state,
      'partDataLoading': false,
      'loading': false,
      'downloading': false,
      'pageSize': 20,
      'pageNumber': 0,
      'itemsCount': 0,
      'balanceInfo': {},
      'list': [],
      'page': [],
    }),
    [ActionTypes.CHANGE_PARTS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_PARTS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.FETCHING_PART]: (state, action) => ({
      ...state,
      'partDataLoading': true,
    }),
    [ActionTypes.FETCHED_PART]: (state, action) => ({
      ...state,
      'partDataLoading': false,
      'partData': action.response.data,
    }),
    [ActionTypes.FETCHED_PART_FAILED]: (state, action) => ({
      ...state,
      'partDataLoading': false,
      'partData': {},
    }),
    [ActionTypes.FETCHING_KARDEX]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_KARDEX]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'itemsCount': action.response.count,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
      'balanceInfo': {
        'initialBalance': action.response.initialBalance,
        'finalBalance': action.response.finalBalance,
      },
    }),
    [ActionTypes.FETCHED_KARDEX_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'page': [],
      'itemsCount': 0,
      'balanceInfo': {},
    }),
    [ActionTypes.DOWNLOADING_KARDEX]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_KARDEX]: (state, action) => {
      downloadFile(action.response.data);

      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_KARDEX_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
